var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgController({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 571H294V875C294 886 285 896 273 896C261 896 252 886 252 875V571H171C148 571 129 552 129 529V462C129 439 148 421 171 421H252V149C252 138 261 128 273 128C285 128 294 138 294 149V421H375C399 421 417 439 417 462V529C417 552 399 570 376 571ZM621 597C644 598 662 618 661 640V707C661 730 643 748 619 748H540V875C540 886 531 896 519 896C507 896 498 886 498 875V748H416C393 748 375 730 375 707V640C374 618 392 599 415 598H498V149C498 138 507 128 519 128C531 128 540 138 540 149V597H621ZM853 287C876 287 895 305 895 329V395C895 418 876 437 853 437H772V875C772 886 763 896 751 896C739 896 730 886 730 875V437H649C625 436 607 418 607 396V329C607 305 625 287 648 287H730V149C730 138 739 128 751 128C763 128 772 138 772 149V287H853ZM853 394V329H649V395L853 394ZM171 463L172 529L375 528V462L171 463ZM619 640V639L531 640C529 640 527 641 524 641H416L417 707L619 706V640Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.6a3e2ee05f80df237719d4c573a6502a.svg";
export { ForwardRef as ReactComponent };